const storeRoute = {
    namespaced: true,
    state: {
        participantId: null,
        page: null,
        section: null,
        orderId: null,
        employerId: null,
        planId: null,
        accountId: null,
        path: null,
        accountTransactionId: null,
        noteId:null,
        invoiceId: null,
        serviceAgreementId: null,
        electionEventId: null
    },
    mutations: {
        update(state, route) {
            for(var prop in state){
                if(!_.isObject(state[prop]) && state[prop] !== null && route[prop] === undefined){
                    state[prop] = null;
                }
            }
            for(var prop in route) {
                if(state[prop] !== undefined) {
                    state[prop] = route[prop];
                }
            }
        },
    }
}

export default storeRoute;



// WEBPACK FOOTER //
// ./src/framework/utils/x-route.js